import { useContext } from "react";
import { ThemeContext } from "../../theme/ThemeContext";
// import CloseIcon from "@mui/icons-material/Close";
import { DialogTitle, IconButton, Typography } from "@mui/material";

import { Dialog, makeStyles } from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import { Divider } from "@mui/material";

import { DialogActions } from "@mui/material";
import CancelButtons from "../../components/DialogBoxComponent/CancelButtons";
import SubmitButtons from "../../components/DialogBoxComponent/SubmitButtons";

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    borderRadius: "5px",
    minWidth: "1000px",
    marginLeft: "90px",
  },
}));

export default function OffenderDialog(props) {
  const classes = useStyles();
  const { darkMode } = useContext(ThemeContext);

  const { onSubmit, children, onClose, ...other } = props;

  const handleClose = () => {
    props.onClose(false);
  };
  return (
    <>
      <Dialog classes={{ paper: classes.dialogPaper }} {...props}>
        <DialogTitle
          variant="h4"
          style={{ color: darkMode ? "#FFFFFF" : "#000000" }}
        >
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 15,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          {props.Header}
        </DialogTitle>
        <Divider
          variant="middle"
          style={{ backgroundColor: darkMode ? "#FFFFFF" : "#000000" }}
        />
        {props.children}
        <DialogActions
          style={{
            justifyContent: "center",
            display: "flex",
            flexDirection: "row",
            marginBottom: "20px",
          }}
        >
          <CancelButtons onClick={onClose}>
            <Typography variant="body1" style={{ textTransform: "none" }}>
              {props.cancelText}
            </Typography>
          </CancelButtons>
          <SubmitButtons onClick={onSubmit} type="submit">
            <Typography variant="body1" style={{ textTransform: "none" }}>
              {props.acceptText}
            </Typography>
          </SubmitButtons>
        </DialogActions>
      </Dialog>
    </>
  );
}
